import React from 'react';
import styles from './NavList.scss';
import classNames from 'classnames';
import { NavigationItemType } from '../../mobile-menu-item/itemTypes';

export const NavList = ({
  inlineChild,
  itemType,
  name,
  children,
  isTwoColumn = false,
}: {
  inlineChild?: boolean;
  itemType: NavigationItemType;
  name: string;
  children: React.ReactNode;
  isTwoColumn?: boolean;
}) => {
  const childItems = isTwoColumn
    ? React.Children.toArray(children).slice(0, 4)
    : React.Children.toArray(children);
  return (
    <ul
      data-testid="submenu-nav-list"
      className={classNames(styles.list, styles[itemType], {
        [styles.inlineChild]: inlineChild,
        [styles.twoColumn]: isTwoColumn,
      })}
    >
      {childItems.map((child, index) => (
        <li
          key={`${name}-${index}`}
          className={classNames(styles.listItem, styles[`pos-${index + 1}`])}
        >
          {child}
        </li>
      ))}
    </ul>
  );
};
